  if (window.location.hash) {
    var hash = window.location.hash.substring(1);
    if (hash === 'accessories') {
      $(".tabs-nav__item-list button:contains('Accessories')").click()
    }
  }
  
  // Quantity and checkbox logic for shoebox product options addon - Andrew
  // function defer(method) {
  //   if (document.querySelector('.spice-spa-addon-input-field')) {
  //     method();
  //   } else {
  //     setTimeout(function () { defer(method) });
  //   }
  // }
  
  // function quantityCheckBox() {
  //   let mountOption = document.querySelectorAll('.spice-spa-addon-product-item');
  
  //   mountOption.forEach(mount => {
  //     let quantityBox = mount.querySelector('[id^="quantity_"]');
  //     let checkBox = mount.querySelector('.spice-spa-addon-checkbox-input');
  //     quantityBox.min = 0;
  //     quantityBox.value = 0;
  
  //     quantityBox.addEventListener('input', (e) => {
  //       if (e.target.value >= 1) {
  //         if (checkBox.checked == false) {
  //           checkBox.click();
  //         }
  //       } else {
  //         if (checkBox.checked == true) {
  //           checkBox.click();
  //         }
  //       }
  //     });
  //   })
  // }
  
  // defer(quantityCheckBox);
  
  
  var accessSelect = document.getElementById("accessory-dropdown")
  
  if (accessSelect) {
    var addToCartButton = document.getElementById("AddToCart")
    addToCartButton.disabled = true;
  
    const addCartStyle = document.createElement('style');
    addCartStyle.type = 'text/css';
    addCartStyle.innerHTML = `
      #AddToCart {
        cursor: not-allowed;
      }
    
      #add-cart-div {
        position: relative;
        display: inline-block;
      }
    
      #accessory-warning {
        position: absolute;
        bottom: 116%;
        color: #fc5328;
        font-weight: bold;
        white-space: nowrap;
      }
    
      #AddToCart:hover + #accessory-warning {
        display: block !important;
      }
    `
    document.head.appendChild(addCartStyle);
  
    accessSelect.addEventListener("change", function () {
      document.head.removeChild(addCartStyle);
      addToCartButton.disabled = false;
  
      addToCartButton.addEventListener("click", function () {
        var aQty = $("input[name='quantity']")[0].value;
        var finalID;
        if (accessSelect.value.includes("parent")) {
          var accInputs = document.getElementsByClassName("accessory-inputs")
          for (let i = 0; i < accInputs.length; i++) {
            if (accInputs[i].getAttribute('data-selected') == "true") {
              finalID = accInputs[i].id;
            }
          }
        } else {
          finalID = accessSelect.value;
        }
        document.documentElement.addEventListener("variant:added", async function () {
          let formData = {
            'items': [{
              'id': finalID,
              'quantity': aQty
            }]
          };
          const response = await fetch(`${window.themeVariables.routes.cartAddUrl}.js`, {
            body: JSON.stringify(formData),
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest"
            }
          });
          if (response.ok) {
            const responseJson = await response.json();
            fetch(`${window.themeVariables.routes.cartUrl}.js`).then(async (response2) => {
              const cartContent = await response2.json();
              document.documentElement.dispatchEvent(new CustomEvent("cart:updated", {
                bubbles: true,
                detail: {
                  cart: cartContent
                }
              }));
            });
            document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: responseJson,
                openMiniCart: window.themeVariables.settings.cartType === "drawer" && this.closest(".drawer") === null
              }
            }));
          } else {
            console.error("Failed to add item to cart:", response.statusText);
          }
        }, { once: true });
      });
    }, { once: true })
  }
